<div class="page-not-found-style">
    <div class="not-found-background">
        @if (errorObject.status === 403) {
        <span class="access-denied-icon"></span>
        }
        <div class="font-color">
            <h1 [class]="errorObject.status === 403 ? 'access-denied' : 'not-found'">{{ errorObject.mainHeading |
                translate }}

            </h1>
            <p class="not-found-message">{{ errorObject.message | translate }}</p>
        </div>
    </div>
</div>